import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { GraphService } from 'src/app/services/Organization/graph.service';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';
import { TemplatesService } from 'src/app/views/templates/templates.service';

@Component({
  selector: 'app-viewfile',
  templateUrl: './viewfile.component.html',
  styleUrls: ['./viewfile.component.css']
})
export class ViewfileComponent implements OnInit {
  previewLink: string;
  loading: boolean;
  driveSpecific: string = 'Template';
  constructor(public dialogRef: MatDialogRef<ViewfileComponent>, private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any, private graphService: GraphService, private _service: TemplatesService) { }

  ngOnInit() {
    this.loading = true;
    if (this.data.iFrameURL) {
      if (this.data.Method == "CaseStudies") {
        this.getPreviewLink();

      }
      // else if (this.data.Method == "Templates") {
      //   this.getTemplatePreviewLink();
      // }
      else {
        this.getTemplatePreviewLink();
      }
    } else {
      this.dialogRef.close();
    }
  }

  getTemplatePreviewLink() {
    this._service.getPreviewUrltemplate(this.data.iFrameURL).subscribe(response => {
      if (response) {
        this.loading = true;
        this.previewLink = response.url;
      }
    }, error => {
      this.loading = false;
      this.dialog.open(InfoDialogComponent, {
        width: '350px',
        data: {
          message:
            'Could not open the file. Please try again after some time or contact administrator',
          class: 'text-danger'
        }
      });
      this.dialogRef.close();
    });
  }
  getKmsPreviewLink() {
    this._service.getPreviewUrltemplate(this.data.iFrameURL).subscribe(response => {
      if (response) {
        this.loading = false;
        this.previewLink = response.url;
      }
    }, error => {
      this.loading = false;
      this.dialog.open(InfoDialogComponent, {
        width: '350px',
        data: {
          message:
            'Could not open the file. Please try again after some time or contact administrator',
          class: 'text-danger'
        }
      });
      this.dialogRef.close();
    });
  }
  showMessage() {
  }

  getPreviewLink() {
    this.graphService.getPreviewUrl(this.data.iFrameURL).subscribe(response => {
      if (response) {
        this.loading = false;
        this.previewLink = response.url;
      }
    }, error => {
      this.loading = false;
      this.dialog.open(InfoDialogComponent, {
        width: '350px',
        data: {
          message:
            'Could not open the file. Please try again after some time or contact administrator',
          class: 'text-danger'
        }
      });
      this.dialogRef.close();
    });
  }
  close() {
    this.dialogRef.close()
  }

}
